import { BASE_PATH } from 'core/config';
import { createBrowserRouter } from 'react-router-dom';

import { commonRoutes } from './commonRoutes';
import { userRoutes } from './user';

export const router = createBrowserRouter([...commonRoutes, ...userRoutes], {
  basename: BASE_PATH,
});
